import { useEffect, useRef, useState } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'
import { Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'
import './stylemobile.css'
import { useGoogleLogin } from 'api/auth/googleLogin'
import { useTwitterLogin } from 'api/auth/twitterLogin'
import { Button } from 'components/Button/Button'
import { Icons } from 'helpers/icons'
import { ContactUs } from 'pages/auth/view/ContactUs/ContactUs'
import { LoginForm } from 'pages/auth/view/LoginForm'
import { RecoverAccount } from 'pages/auth/view/RecoverAccount/RecoverAccount'
import { ResetPassword } from 'pages/auth/view/RecoverAccount/ResetPassword'
import {
    Register,
    registrationOpen
} from 'pages/auth/view/Register/Register'

// eslint-disable-next-line import/order
import { useTranslation } from 'react-i18next'

import AcceptableUseModal from '../modals/AcceptableUseModal'
import CCPAPolicyModal from '../modals/CCPAPolicyModal'
import ComplaintsPolicyModal from '../modals/ComplaintsPolicyModal'
import CookiePolicyModal from '../modals/CookiePolicyModal'
import CreatorTermsModal from '../modals/CreatorTermsModal'
import DMCAModal from '../modals/DMCAModal'
import FanCreatorContractModal from '../modals/FanCreatorContractModal'
import PrivacyPolicyModal from '../modals/PrivacyPolicyModal'
import ReferralTermsModal from '../modals/ReferralTermsModal'
import TermsModal from '../modals/TermsModal'
import USCModal from '../modals/USCModal'


const MobileView = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [activePanel, setActivePanel] = useState(() =>
        sessionStorage.getItem('pending_social_2fa')
            ? 'login'
            : 'default'
    )
    const openTwitterLoginMutation = useTwitterLogin()
    const getGoogleRedirectURL = useGoogleLogin()
    const { t } = useTranslation()
    const toggleMenu = () => {
        setIsMenuOpen(prev => !prev)
    }
    const navigate = useNavigate()
    const location = useLocation()
    const [showModal, setShowModal] = useState(false)
    const [selectedLanguage, setSelectedLanguage] = useState({
        flag: '/flags/us.svg'
    })

    const contentRef = useRef<HTMLDivElement | null>(null)

    const handleOptionClick = (flag: any, lang: any) => {
        setSelectedLanguage({ flag })
        setShowModal(false)
    }
    useEffect(() => {
        document.addEventListener('click', e => {
            const target = e.target as HTMLElement
            if (
                !target.closest('#pf-language-selector') &&
                !target.closest('#pf-selectedLanguage')
            ) {
                setShowModal(false)
            }
        })
    }, [selectedLanguage])

useEffect(() => {
    const params = new URLSearchParams(location.search)

    if (
        params.get('reset_password') === '1' &&
        params.get('token') &&
        params.get('email')
    ) {
        setActivePanel('resetPassword')
        return
    }

    if (location.pathname === '/contact') {
        setActivePanel('contact')
    }
}, [location.pathname, location.search])
useEffect(() => {
    const handleBack = () => {
        setActivePanel('default')
    }

    window.addEventListener('mobile-auth-back', handleBack)

    return () => {
        window.removeEventListener('mobile-auth-back', handleBack)
    }
}, [])

const scrollAuthUp = () => {
    if (window.innerWidth > 768) return

    window.scrollTo({
        top: 240,
        behavior: 'auto'
    })
}
const lastScrollAt = useRef(0)

const scrollAuthInputIntoPlace = (
    e: React.SyntheticEvent<HTMLElement>
) => {
    if (window.innerWidth > 768) return

    const now = Date.now()

    if (now - lastScrollAt.current < 250) return
    lastScrollAt.current = now

    const input = e.currentTarget.querySelector('input')
    if (!input) return

    requestAnimationFrame(() => {
        const rect = input.getBoundingClientRect()

        window.scrollBy({
            top: rect.top - 60,
            behavior: 'auto'
        })
    })
}

useEffect(() => {
    const setMobilePageHeight = () => {
        if (window.innerWidth > 768) {
            document.documentElement.style.removeProperty(
                '--mobile-page-height'
            )
            return
        }

        document.documentElement.style.setProperty(
            '--mobile-page-height',
            `${window.innerHeight}px`
        )
    }

    const handleOrientationChange = () => {
        setTimeout(setMobilePageHeight, 300)
    }

    setMobilePageHeight()

    window.addEventListener('orientationchange', handleOrientationChange)

    return () => {
        window.removeEventListener('orientationchange', handleOrientationChange)
        document.documentElement.style.removeProperty('--mobile-page-height')
    }
}, [])

const googleLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/redirect_to_google`
}

    const twitterLogin = async () => {
        if (openTwitterLoginMutation.isLoading) {
            return
        }
        openTwitterLoginMutation.mutate()
    }


return (
    <div>
        {activePanel !== 'terms' && (
            <div className='pf-page'>
{/*                 <button
                    className={`pf-menu ${isMenuOpen ? 'active' : ''}`}
                    onClick={() => {
                        toggleMenu()
                        setActivePanel(
                            activePanel === 'menu' ? 'default' : 'menu'
                        )
                    }}
                    aria-label='Toggle Menu'
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button> */}
                <div className='pf-page__content' ref={contentRef}>
                    <div className='pf-page__card'>
                        <div className='pf-page__logo'>
                            <div className='pf-page__logo-content'>
                                <img
                                    src='/logo.png'
                                    alt='AllFans'
                                    className='pf-page__logo-image'
                                />
                            </div>
                        </div>
                        <div className='pf-page__panel' id='panel-first'>
                            {(activePanel === 'default' ||
                                activePanel === 'menu') && (
                                <>
                                    <img
                                        src='/af-dark.svg'
                                        alt='AllFans'
                                        className='pf-page__title-logo'
                                    />
                                    <Swiper
                                        pagination={{ clickable: true }}
                                        autoplay={{
                                            delay: 3000,
                                            disableOnInteraction: false
                                        }}
                                        modules={[Pagination, Autoplay]}
                                        className='swiper'
                                    >
                                        <div className='swiper-wrapper'>
                                            <SwiperSlide>
                                                <p>
                                                    A cutting-edge content
                                                    creator platform for the
                                                    savvy modern creator.
                                                </p>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <p>
                                                    A smarter platform for a new era of creators. Advanced analytics, intelligent automation.
                                                </p>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <p>
                                                    Data-driven growth tools designed to help scale faster, engage deeper, and maximize revenue.
                                                </p>
                                            </SwiperSlide>
                                        </div>
                                    </Swiper>
                                </>
                            )}
{activePanel === 'default' && (
    <div className='pf-page__actions'>
        <button
            className='btn btn-primary'
            style={{ height: '5rem' }}
            onClick={() => setActivePanel('signup')}
        >
            {registrationOpen ? 'Sign Up' : 'Pre Register'}
        </button>

        <button
            className='btn btn-default'
            style={{ height: '5rem' }}
            onClick={() => setActivePanel('login')}
        >
            Login
        </button>
    </div>
)}
                            {activePanel === 'menu' && (
                                <div className='pf-page__actions'>
                                    <a href='#' className='btn btn-default'>
                                        Features
                                    </a>
                                    <a href='/how-to/faq' className='btn btn-default'>
                                        FAQ
                                    </a>
                                </div>
                            )}
                        </div>
                        {/* Auth forms always mounted, only one shown */}
                        <div className='pf-auth__container'>
                            <div style={{ display: activePanel === 'signup' ? 'block' : 'none' }}>
                                <div className='pf-page__close'>
                                    <img
                                        className='modal__card__withoutTitle__close'
                                        onClick={() => {
                                            if (
                                                window.location.pathname.includes('/') ||
                                                window.location.pathname.includes('/')
                                            ) {
                                                navigate(-1)
                                                return
                                            }
                                            setActivePanel('default')
                                        }}
                                        src={Icons.close}
                                        alt={'closeModal'}
                                    />
                                </div>
                                <Register onInputFocus={scrollAuthInputIntoPlace} />
                            </div>
                            <div style={{ display: activePanel === 'login' ? 'block' : 'none' }}>
                                <div className='pf-page__close'>
                                    <img
                                        className='modal__card__withoutTitle__close'
                                        onClick={() => {
                                            if (
                                                window.location.pathname.includes('/') ||
                                                window.location.pathname.includes('/')
                                            ) {
                                                navigate(-1)
                                                return
                                            }
                                            setActivePanel('default')
                                        }}
                                        src={Icons.close}
                                        alt={'closeModal'}
                                    />
                                </div>
                                <LoginForm setActivePanel={setActivePanel} onInputFocus={scrollAuthUp} />
                            </div>
                            <div style={{ display: activePanel === 'forgetPassword' ? 'block' : 'none' }}>
                                <div className='pf-page__close'>
                                    <img
                                        className='modal__card__withoutTitle__close'
                                        onClick={() => {
                                            // You probably want to return to login after recover
                                            setActivePanel('login')
                                        }}
                                        src={Icons.close}
                                        alt={'closeModal'}
                                    />
                                </div>
                                <RecoverAccount setActivePanel={setActivePanel} />
                            </div>
                            <div
    style={{
        display:
            activePanel === 'resetPassword'
                ? 'block'
                : 'none'
    }}
>
    <div className='pf-page__close'>
        <img
            className='modal__card__withoutTitle__close'
            onClick={() => {
                navigate('/', {
                    replace: true
                })
                setActivePanel('login')
            }}
            src={Icons.close}
            alt='closeModal'
        />
    </div>

    <ResetPassword
        setActivePanel={setActivePanel}
    />
</div>
                        </div>

        {!registrationOpen && (
            <div style={{ height: '1rem' }} />
        )}

                        {/* Social login (shared) */}
{registrationOpen &&
    ![
        'forgetPassword',
        'resetPassword'
    ].includes(activePanel) && (
                            <>
                                <div className='divider'>
                                    <span>Or</span>
                                </div>
                                <div className='pf-page__social'>
                                    <Button
                                        text={t('')}
                                        color='white'
                                        customClass='pf-page__social_google'
                                        hasCircleIcon={true}
                                        circleIcon={Icons.twitter}
                                        circleIconBg='twitter'
                                        clickFn={twitterLogin}
                                    />
                                    <Button
                                        text={t('')}
                                        color='white'
                                        customClass='pf-page__social_google'
                                        hasCircleIcon={true}
                                        circleIcon={Icons.google}
                                        circleIconBg='google'
                                        clickFn={async () =>
                                            googleLogin()
                                            }
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <footer className='pf-footerMobile'>
                        <div className='pf-footerMobile__inner'>
                            <div className='pf-footerMobile__actions'>
                                <p className='pf-footerMobile__copyright'>
                                    &copy; 2026 AllFans.
                                </p>
                               <>
{/*                             <div style={{ position: 'relative' }}>
                                <div
                                    id='pf-language-selector'
                                    className='pf-language-selector'
                                >
                                    <div
                                        className='pf-selected'
                                        id='pf-selectedLanguage'
                                        onClick={() => setShowModal(true)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <img
                                            src={selectedLanguage.flag}
                                            alt='Flag'
                                            id='pf-selectedFlag'
                                            width={32}
                                        />
                                    </div>

                                    <div
                                        className='pf-options'
                                        id='pf-languageOptions'
                                        style={{ display: 'none' }}
                                    />
                                </div>

                                {showModal && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '-200px',
                                            right: 0,
                                            backgroundColor: '#fff',
                                            border: '1px solid #ccc',
                                            borderRadius: '10px',
                                            width: '230px',
                                            height: '200px',
                                            overflowY: 'auto'
                                        }}
                                        className=''
                                        id=''
                                        onClick={() => setShowModal(false)}
                                    >
                                        <div>
                                            <div >
                                                {[
                                                    {
                                                        flag: '/flags/us.svg',
                                                        lang: 'English (USA)'
                                                    },
                                                    {
                                                        flag: '/flags/ug.svg',
                                                        lang: 'Ugandian'
                                                    },
                                                    {
                                                        flag: '/flags/ur.svg',
                                                        lang: 'Uruguayan'
                                                    },
                                                    {
                                                        flag: '/flags/uae.svg',
                                                        lang: 'Arabic'
                                                    }
                                                ].map(option => (
                                                    <div
                                                        style={{
                                                            cursor: 'pointer',
                                                            padding: '5px',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}
                                                        className='pf-option'
                                                        key={option.lang}
                                                        data-flag={option.flag}
                                                        data-lang={option.lang}
                                                        onClick={() =>
                                                            handleOptionClick(
                                                                option.flag,
                                                                option.lang
                                                            )
                                                        }
                                                    >
                                                        <div className='pf-option__flag'>
                                                            <img
                                                                src={
                                                                    option.flag
                                                                }
                                                                alt='Flag'
                                                                style={{
                                                                    width: '24px',
                                                                    height: '16px'
                                                                }}
                                                            />
                                                        </div>
                                                        <span>
                                                            {option.lang}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div> */}
                        </>
                            </div>
                            <div className='pf-footerMobile__links'>
                                <a
                                    onClick={() => {
                                        setActivePanel('terms')
                                    }}
                                    className='modal-trigger'
                                    data-target='modal-example'
                                >
                                    Terms Of Service
                                </a>
                                <a
                                    onClick={() => {
                                        setActivePanel('dmca')
                                    }}
                                    className='modal-trigger'
                                    data-target='modal-example'
                                >
                                    DMCA
                                </a>
                                <a
                                    onClick={() => {
                                        setActivePanel('privacy')
                                    }}
                                    className='modal-trigger'
                                    data-target='modal-example'
                                >
                                    Privacy Policy
                                </a>
                                <a
                                    onClick={() => {
                                        setActivePanel('complaints')
                                    }}
                                    className='modal-trigger'
                                    data-target='modal-example'
                                >
                                    Complaints Policy
                                </a>
                                <a
                                    onClick={() => {
                                        setActivePanel('becomecreator')
                                    }}
                                    className='modal-trigger'
                                    data-target='modal-example'
                                >
                                    Become A Creator
                                </a>
                                <a
                                    onClick={() => {
                                        setActivePanel('creatorterms')
                                    }}
                                    className='modal-trigger'
                                    data-target='modal-example'
                                >
                                    Creator Terms
                                </a>
                                <a
                                    onClick={() => {
                                        setActivePanel('cookiepolicy')
                                    }}
                                    className='modal-trigger'
                                    data-target='modal-example'
                                >
                                    Cookie Policy
                                </a>
                                <a
                                    onClick={() => {
                                        setActivePanel('fancreatorcontract')
                                    }}
                                    className='modal-trigger'
                                    data-target='modal-example'
                                >
                                    Fan/Creator Contract
                                </a>
                                <a
                                    onClick={() => {
                                        setActivePanel('2257')
                                    }}
                                    className='modal-trigger'
                                    data-target='modal-example'
                                >
                                    USC 2257
                                </a>
                                <a
                                    onClick={() => {
                                        setActivePanel('acceptableuse')
                                    }}
                                    className='modal-trigger'
                                    data-target='modal-example'
                                >
                                    Acceptable Use Policy
                                </a>
                                <a
                                    onClick={() => {
                                        setActivePanel('referralprogram')
                                    }}
                                    className='modal-trigger'
                                    data-target='modal-example'
                                >
                                    Referral Program Terms
                                </a>
                                <a
                                    onClick={() => {
                                        setActivePanel('ccpapolicy')
                                    }}
                                    className='modal-trigger'
                                    data-target='modal-example'
                                >
                                    CCPA Privacy Policy
                                </a>
                                <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault()
                                    setActivePanel('contact')
                                }}
                                >
                                Contact Us
                                </a>
                            </div>
                        </div>
                    </footer>
                    <div className='pf-page__background'>
                        <img
                            src='/mobile-bg.jpg'
                            alt='bg'
                            srcSet='/mobile-bg.jpg, /mobile-bg@2x.png 2x'
                        />
                    </div>
                </div>
            )}
            {activePanel === 'terms' && (
            <div className='pf-modal-overlay'>
                <TermsModal onClose={() => setActivePanel('default')} />
            </div>
            )}
            {activePanel === 'acceptableuse' && (
            <div className='pf-modal-overlay'>
                <AcceptableUseModal onClose={() => setActivePanel('default')} />
            </div>
            )}
            {activePanel === 'privacy' && (
            <div className='pf-modal-overlay'>
                <PrivacyPolicyModal onClose={() => setActivePanel('default')} />
            </div>
            )}
            {activePanel === '2257' && (
            <div className='pf-modal-overlay'>
                <USCModal onClose={() => setActivePanel('default')} />
            </div>
            )}
            {activePanel === 'dmca' && (
            <div className='pf-modal-overlay'>
                <DMCAModal onClose={() => setActivePanel('default')} />
            </div>
            )}
            {activePanel === 'referralprogram' && (
            <div className='pf-modal-overlay'>
                <ReferralTermsModal onClose={() => setActivePanel('default')} />
            </div>
            )}
            {activePanel === 'cookiepolicy' && (
            <div className='pf-modal-overlay'>
                <CookiePolicyModal onClose={() => setActivePanel('default')} />
            </div>
            )}
            {activePanel === 'complaints' && (
            <div className='pf-modal-overlay'>
                <ComplaintsPolicyModal onClose={() => setActivePanel('default')} />
            </div>
            )}
            {activePanel === 'fancreatorcontract' && (
            <div className='pf-modal-overlay'>
                <FanCreatorContractModal onClose={() => setActivePanel('default')} />
            </div>
            )}
            {activePanel === 'creatorterms' && (
            <div className='pf-modal-overlay'>
                <CreatorTermsModal onClose={() => setActivePanel('default')} />
            </div>
            )}
             {activePanel === 'ccpapolicy' && (
            <div className='pf-modal-overlay'>
                <CCPAPolicyModal onClose={() => setActivePanel('default')} />
            </div>
            )}
            {activePanel === 'contact' && (
            <div className='pf-modal-overlay'>
                <div className='pf-page__close'>
                <img
                    className='modal__card__withoutTitle__close'
                    src={Icons.close}
                    alt='closeModal'
                    onClick={() => setActivePanel('default')}
                />
                </div>
                <ContactUs
                setActivePanel={setActivePanel}
                onClose={() => setActivePanel('default')}
                />
            </div>
            )}
        </div>
    )
}

export default MobileView
